import Style from "./PrimaryButton.module.css";

const PrimaryButton = ({
  onClick,
  children,
  padding,
  width,
  height,
  borderRadius,
  fontSize,
  style,
  ariaLabel,
  title,
}) => {
  return (
    <button
      className={Style["primary-btn"]}
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
      style={{ width, height, borderRadius, fontSize, padding, ...style }}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
